export default function Terms() {
  return (
    <div style={{
      maxWidth: "900px",
      margin: "20px auto",
      padding: "40px",
      fontFamily: "Arial, sans-serif",
      lineHeight: "1.8",
      color: "#1a1a1a",
      backgroundColor: "#fdfdfd",
      borderRadius: "8px",
      boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
    }}>
      
      <h1 style={{ fontSize: "32px", fontWeight: "700", marginBottom: "25px", color: "#0d47a1" }}>
        Terms and Conditions
      </h1>

      <p style={{ fontSize: "16px" }}>
        These terms and conditions outline the rules and regulations for the use of GameHub,
        accessible from gamehub.samsoftix.com.
      </p>

      <h2 style={{ fontSize: "24px", marginTop: "35px", color: "#0d47a1" }}>Acceptance of Terms</h2>
      <p style={{ fontSize: "16px" }}>
        By accessing and using this website, you accept and agree to be bound by these Terms and Conditions.
        If you do not agree with any part of these terms, please discontinue using GameHub.
      </p>

      <h2 style={{ fontSize: "24px", marginTop: "35px", color: "#0d47a1" }}>Use of the Website</h2>
      <p style={{ fontSize: "16px" }}>
        Users may access the games and content provided for personal, non-commercial use only.
        You agree not to:
      </p>
      <ul style={{ paddingLeft: "20px", fontSize: "16px", color: "#333" }}>
        <li>Copy or redistribute the games without authorization</li>
        <li>Exploit the website for commercial gain unless permitted</li>
        <li>Inject malicious code or attempt unauthorized access</li>
        <li>Engage in behavior that could harm the functioning of GameHub</li>
      </ul>

      <h2 style={{ fontSize: "24px", marginTop: "35px", color: "#0d47a1" }}>Intellectual Property</h2>
      <p style={{ fontSize: "16px" }}>
        All content, branding, UI design, and games on GameHub are the exclusive property of SamSoftix unless otherwise stated.
        Unauthorized use or reproduction is strictly prohibited.
      </p>

      <h2 style={{ fontSize: "24px", marginTop: "35px", color: "#0d47a1" }}>Disclaimer</h2>
      <p style={{ fontSize: "16px" }}>
        All games and content are provided “as-is” without warranty of any kind. We do not guarantee that:
      </p>
      <ul style={{ paddingLeft: "20px", fontSize: "16px", color: "#333" }}>
        <li>The games will always function error-free</li>
        <li>The website will be uninterrupted or secure</li>
        <li>Gameplay scores or progress are always preserved</li>
      </ul>
      <p style={{ fontSize: "16px" }}>
        GameHub shall not be held liable for any loss or damage arising from use of the website.
      </p>

      <h2 style={{ fontSize: "24px", marginTop: "35px", color: "#0d47a1" }}>Third-Party Advertisements</h2>
      <p style={{ fontSize: "16px" }}>
        GameHub may display advertisements from Google AdSense or other advertisers.
        We are not responsible for the content or accuracy of third-party advertisements.
        Clicking ads is at your own discretion.
      </p>

      <h2 style={{ fontSize: "24px", marginTop: "35px", color: "#0d47a1" }}>Links to Other Websites</h2>
      <p style={{ fontSize: "16px" }}>
        GameHub may contain links to external websites. We do not control or endorse the content on third-party sites,
        and users access them at their own risk.
      </p>

      <h2 style={{ fontSize: "24px", marginTop: "35px", color: "#0d47a1" }}>Termination of Access</h2>
      <p style={{ fontSize: "16px" }}>
        We reserve the right to restrict or terminate access to the website for users who violate these terms.
      </p>

      <h2 style={{ fontSize: "24px", marginTop: "35px", color: "#0d47a1" }}>Modifications to Terms</h2>
      <p style={{ fontSize: "16px" }}>
        We may update these Terms & Conditions at any time. Modifications are effective when posted on this page.
      </p>

      <h2 style={{ fontSize: "24px", marginTop: "35px", color: "#0d47a1" }}>Contact Information</h2>
      <p style={{ fontSize: "16px" }}>
        For any inquiries regarding these Terms & Conditions, you may contact us at:
        <br /><br />
        Email: <a href="mailto:samsoftix@gmail.com" style={{ color: "#0d47a1" }}>samsoftix@gmail.com</a>
      </p>

      <p style={{ marginTop: "40px", fontSize: "14px", color: "#555" }}>
        Last updated: {new Date().toDateString()}
      </p>

    </div>
  );
}
